<template>
  <div id="app">
    <nav-bar/>
    <router-view class="app-main"/>
    <footer-bar/>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import FooterBar from '@/components/FooterBar.vue'
export default {
  components: {
    NavBar,
    FooterBar
  },
  mounted () {
    window.onscroll = this.windowOnscroll
  },
  methods: {
    /**
     * 屏幕滚动事件
     */
    windowOnscroll () {
      this.$store.state.scrollTop = document.documentElement.scrollTop || document.body.srcollTop || 0
    }

  }
}
</script>

<style lang="less">
html {
  background-color: #FFFFFF;
  min-width: 1200px;
  font-size: 10px;
}
body {
  margin: 0;
  cursor: default;
}
img {
  display: block;
  width: 100%;
  object-fit: cover;
}
video {
  display: block;
  width: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #434343;
  position: relative;
  font-weight: normal;
}
.app-main {
  min-height: calc(100vh - 20rem);
  box-sizing: border-box;
}
.animation-delay-300ms {
  animation-delay: 0.3s;
}
.animation-delay-500ms {
  animation-delay: 0.5s;
}
</style>
